import { useSelector, shallowEqual } from 'react-redux';
import { TradeContext } from '../../types/trade';

const useCurrentTradeContext = (): TradeContext => {
  return useSelector(state => state.ui?.nav?.primary?.context, shallowEqual);
};

export default useCurrentTradeContext;
